<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31">
    <g fill="none" fill-rule="evenodd">
      <g fill-rule="nonzero">
        <g>
          <g>
            <g>
              <g>
                <path
                  fill="#164194"
                  d="M22.917 8.021l-2.292-5.73h-4.583V0H0v16.042h3.648c.474 1.332 1.732 2.292 3.226 2.292 1.495 0 2.753-.96 3.228-2.292h7.296c.473 1.332 1.732 2.292 3.227 2.292 1.495 0 2.754-.96 3.227-2.292H27.5V9.167L22.917 8.02z"
                  transform="translate(-1008 -680) translate(127 318) translate(855 292) translate(26 70) translate(1.25 6.25)"
                />
                <path
                  fill="#E1F5FE"
                  d="M20.448 8.021L19.074 4.584 16.042 4.584 16.042 8.021zM13.75 2.292H2.291V13.75h1.357c.474-1.333 1.733-2.291 3.227-2.291 1.494 0 2.753.958 3.227 2.291h3.648V2.292zM6.875 13.75c-.632 0-1.146.514-1.146 1.146 0 .632.514 1.146 1.146 1.146.632 0 1.146-.514 1.146-1.146 0-.632-.514-1.146-1.146-1.146M20.625 13.75c-.63 0-1.146.514-1.146 1.146 0 .632.515 1.146 1.146 1.146.631 0 1.146-.514 1.146-1.146 0-.632-.515-1.146-1.146-1.146M16.042 10.313v3.437h1.356c.473-1.333 1.732-2.291 3.227-2.291 1.495 0 2.754.958 3.227 2.291h1.356v-2.794l-2.573-.643h-6.593z"
                  transform="translate(-1008 -680) translate(127 318) translate(855 292) translate(26 70) translate(1.25 6.25)"
                />
                <path
                  fill="#13A2E8"
                  d="M18.333 2.292L20.625 2.292 20.625 0 18.333 0zM5.156 7.734L7.159 7.734 7.159 9.739 8.878 9.739 8.878 7.734 10.885 7.734 10.885 6.016 8.878 6.016 8.878 4.011 7.159 4.011 7.159 6.016 5.156 6.016z"
                  transform="translate(-1008 -680) translate(127 318) translate(855 292) translate(26 70) translate(1.25 6.25)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>